export default {
  storeColors(data) {
    return axios.post('/brand-colors/store', data)
  },

  checkDuplicate(data) {
    return axios.post('/brand-colors/check_duplicate', data)
  },
}
